/* eslint-disable react/no-danger */
/* eslint-disable no-confusing-arrow */
/* eslint-disable react/prop-types */
import { memo } from 'react';
import { Link } from 'react-router-dom';

import TableRow from '../common/table/TableRow';
import CannabisLicenseHelper from '../../helpers/features/CannabisLicensesHelper';

function LicenseRow({ data, selectedRow }) {
  return (
    <TableRow>
      {CannabisLicenseHelper.LICENSES_TABLE_HEADERS.map(item =>
        !item.db_key ? (
          <td>
            <span>
              {/* eslint-disable react/jsx-curly-brace-presence */}
              <Link to={`/cannabis-licenses/${data.id}`}>Details</Link>
            </span>
          </td>
        ) : (
          <td onClick={() => selectedRow(data)} style={{ cursor: 'pointer' }}>
            <span>{data[item.db_key]}</span>
          </td>
        ),
      )}
    </TableRow>
  );
}

export default memo(LicenseRow);
